import React from 'react'

import clsx from 'clsx'

import classes from './Collapse.module.scss'

/** @type {import("./types.d").default} */
const Collapse = ({ className, open = false, children }) => {
  return (
    <div
      className={clsx('Collapse', classes.root, className, {
        [classes.open]: open,
      })}
    >
      {children}
    </div>
  )
}

export default Collapse
